import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import { GlobalVariable, AzureSearchVariables } from '../shared/global';

@Injectable()
export class CheckAvailabilityService {

  private baseApiUrlTest = GlobalVariable.BASE_API_URL;

  url: string = "https://htwpgcy9zl.execute-api.us-east-1.amazonaws.com/Prod/api/autocomplete/";

  private address_url = this.baseApiUrlTest + 'api/rest/v1/street/ercot/embed/search/';

  private address_hash_url = this.baseApiUrlTest + 'api/enrollment/street/ercot/hash/search';

  private azure_headers: Headers = new Headers();


  constructor(private http: Http) {
    this.azure_headers.append('content-type', 'application/json');
    this.azure_headers.append('api-key', AzureSearchVariables.adminKey);
    this.azure_headers.append('Access-Control-Allow-Origin', '*');
  }

  search(searchKey: string) {
    return this.http
      .get(this.url + searchKey)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  direct_search(searchKey: string) {
    var searchUrl = AzureSearchVariables.searchUrl + `&search=${searchKey}`;

    let options = new RequestOptions({ headers: this.azure_headers })

    return this.http.get(searchUrl, options)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  getServiceAddresses(address: Object) {
    return this.http
      .post(this.address_url, address)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  /** Search Service Providers by Full Address HashKey */
  GetServiceAddressesByHash(address: Object) {
    return this.http
      .post(this.address_hash_url, address)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/check-availability/check-availability.service.ts